import { useGetTariffsQuery } from 'Services/ProductManagement/Features/Tariff/tariffApi'
import {
  type FetchTariffListParams,
  TariffStatus
} from 'Services/ProductManagement/Features/Tariff/types'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { updateFilterQueryParam } from 'Util/updateFilterQueryParam'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

function useTariffsWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()
  const showPassive = searchParams.get('show_passive') === 'true'

  const [searchQueryParams, setSearchQueryParams] = useState<FetchTariffListParams>({
    filter:
      searchParams.get('filter') ??
      (showPassive ? undefined : `status ne "${TariffStatus.PASSIVE}"`),
    search_text: searchParams.get('search_text') ?? undefined,
    sort_by: searchParams.get('sort_by') ?? 'tariffCode',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT
  })

  const {
    data: { resources: tariffs } = { resources: [] },
    data: { total_results: totalResults } = { total_results: 0 },
    isFetching
  } = useGetTariffsQuery(searchQueryParams)

  const setQueryParams = () => {
    Object.entries(searchQueryParams).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [searchQueryParams])

  const setShowPassive = (next: boolean) => {
    setSearchParams(prev => {
      if (next) prev.set('show_passive', 'true')
      else prev.delete('show_passive')
      return prev
    })
    setSearchQueryParams(prev => ({
      ...prev,
      filter: updateFilterQueryParam(
        prev.filter,
        'status',
        next ? undefined : `status ne "${TariffStatus.PASSIVE}"`
      ),
      start_index: undefined
    }))
  }

  return {
    tariffs,
    isFetching,
    searchQueryParams,
    setSearchQueryParams,
    showPassive,
    setShowPassive,
    totalResults
  }
}

export default useTariffsWithParams
